class AbstractPaymentMethodConfig {
    constructor() {
        /**
         * Allow cardholder not present transactions?
         *
         * @type {boolean}
         */
        this.allowCnp = true;

        /**
         * Log debug messages to the console?
         *
         * @type {boolean}
         */
        this.debug = true;
    }

    getHydrationMap() {
        return {};
    }

    /**
     * Returns true if this is a valid configuration.
     * Otherwise, throws an error.
     *
     * @return {boolean}
     */
    validate() {
        return true;
    }
}

module.exports = AbstractPaymentMethodConfig;
